import { useTranslation } from "@repo/shared/i18n";

/*
  `calculateAccelerate` returns the English AcceleRATE name and the chemstyle
  groups are keyed by it, so the id stays English and only display goes
  through this lookup (same shape as the filter option labels). Unknown
  strings fall through untouched.
*/
const ACCELERATE_LABEL_KEYS = {
  Explosive: "filters.accelerates.explosive",
  Controlled: "filters.accelerates.controlled",
  Lengthy: "filters.accelerates.lengthy",
} as const;

type AccelerateLabelKey =
  (typeof ACCELERATE_LABEL_KEYS)[keyof typeof ACCELERATE_LABEL_KEYS];

export const useAccelerateLabel = () => {
  const { t } = useTranslation("players");
  return (accelerate: string | undefined) => {
    const key = (ACCELERATE_LABEL_KEYS as Record<string, AccelerateLabelKey>)[
      accelerate ?? ""
    ];
    return key ? t(key) : accelerate;
  };
};
